import Joi from 'joi'

const ValidationSchema = Joi.object({
  driverId: Joi.number().required(),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .label('Email'),
  firstName: Joi.string().required().label('First Name'),
  lastName: Joi.string().required().label('Last Name'),
  name: Joi.string().required().label('Driver Name'),
  username: Joi.string().required().label('Username'),
})

export default ValidationSchema
